import LogoutIcon from "shared/components/utils/icons/Logout";
import MenuItem from "@material-ui/core/MenuItem";
import Text from "shared/components/data-display/mui/Text";
import { clearToken } from "app/auth/authService";
import { useMsal } from "@azure/msal-react";
import { TextWrapper } from "./MenuProfileSignOutItem.styles";

const MenuProfileSignOutItem = () => {
    const { instance } = useMsal();
    const handleLogout = () => {
        instance.logout();
        clearToken();
    };
    return (
        <MenuItem onClick={handleLogout}>
            <LogoutIcon />
            <TextWrapper>
                <Text variant="medium">Log out</Text>
            </TextWrapper>
        </MenuItem>
    );
};

MenuProfileSignOutItem.propTypes = {};

export default MenuProfileSignOutItem;
